import { useState, useEffect } from 'react';
import { DefaultOptionType } from 'antd/es/select';
import he from 'he';

import { JsonData } from 'types';

export const useTableSearch = (data: JsonData, searchKey: string, showAllIfEmpty: boolean) => {
  const [options, setOptions] = useState<DefaultOptionType[]>([]);
  const [search, setSearch] = useState('');

  const formatOptions = (list: JsonData): DefaultOptionType[] =>
    list?.slice(0, showAllIfEmpty ? list.length : 10).map(({ ID, name, task_type_ID, desc }) => ({
      value: ID || task_type_ID,
      label: he.decode(name || desc),
    }));

  const handleSearch = (value: string) => {
    setSearch(value);
    if (!value) {
      if (showAllIfEmpty) {
        setOptions(formatOptions(data));
      } else {
        setOptions([]);
      }
      return;
    }

    const filtered = data.filter((item) => item[searchKey]?.toLowerCase().startsWith(value.toLowerCase()));

    setOptions(formatOptions(filtered));
  };

  useEffect(() => {
    if (showAllIfEmpty) {
      handleSearch('');
    }
  }, [data, showAllIfEmpty]);

  return { options, search, handleSearch };
};
